import React, { useState } from "react";
import HorizontalTabs from "../../../common/HorizontalTabs";
import ApiVersionManager from "./ApiVersion";
import ShowDocument from "./ShowDocument";
import VersionComparison from "./VersionComparision";
import { useRepoContext } from "./ContractContext";

type Props = {};

const Index = (props: Props) => {
  const { selectedRepo, selectedVersion } = useRepoContext();
  const [activeTab, setActiveTab] = useState("tab1");

  const tabs = [
    {
      id: "tab1",
      label: "API Collection Manager",
      content: (
        <ApiVersionManager
          repo={selectedRepo}
          goToTab={setActiveTab}
          activeTab={activeTab}
        />
      ),
    },
    {
      id: "tab2",
      label: "API Documentation",
      content: <ShowDocument repo={selectedRepo} version={selectedVersion} />,
    },
    {
      id: "tab3",
      label: "Compare Versions",
      content: <VersionComparison repo={selectedRepo} activeTab={activeTab} />,
    },
  ];

  return (
    <HorizontalTabs
      tabs={tabs}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
};

export default Index;
